import { useRef } from "react";
import { Box, Button, Group, Stack } from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import { useReactToPrint } from "react-to-print";
import { PurchaseOrderResponseType } from "constants/types/purchaseOrder";
import { PAGE_STYLE } from "constants/common/purchaseOrder";
import PurchaseOrderPrintTemplate from "./components/PurchaseOrderPrintTemplate/PurchaseOrderPrintTemplate";

interface Props {
  purchaseOrder: PurchaseOrderResponseType;
}

const PurchaseOrderPrintContent = ({ purchaseOrder }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `phieu-mua-hang-${purchaseOrder.code}`,
    pageStyle: PAGE_STYLE,
  });

  return (
    <Stack gap="sm">
      <Group justify="flex-end">
        <Button leftSection={<IconPrinter size={16} />} onClick={() => handlePrint()}>
          In phiếu
        </Button>
      </Group>

      <Box
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          backgroundColor: "#f0f0f0",
          padding: 16,
          borderRadius: 4,
        }}
      >
        <Box
          style={{
            maxWidth: 794,
            margin: "0 auto",
            backgroundColor: "#ffffff",
            padding: "30px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          }}
        >
          <PurchaseOrderPrintTemplate ref={contentRef} purchaseOrder={purchaseOrder} />
        </Box>
      </Box>
    </Stack>
  );
};

export default PurchaseOrderPrintContent;
